export type SUPPORTED_LANGUAGES = 'en' | 'ar' | string;
export const DEFAULT_LANGUAGE = 'en';

export const DRAFT_EVENT_COLOR = '808080';
export const DEFAULT_DATE_FORMAT = 'dd-MM-yyyy HH:mm';

export const INTERNATIONAL_PHONE_NUMBER_REGEX = /^\+(?:[0-9] ?-?){6,14}[0-9]$/;
export const URL_REGEX = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}(:[0-9]{1,5})?(\/\S*)?$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
